module.exports = __webpack_public_path__ + "img/icon_1_21.b100e2dc.png";